import { render, staticRenderFns } from "./CustomIframe.vue?vue&type=template&id=4bc1b644&scoped=true&"
import script from "./CustomIframe.vue?vue&type=script&lang=js&"
export * from "./CustomIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc1b644",
  null
  
)

export default component.exports